import Warning from "../../src/assets/svg/warning.svg";
// import Info from "../../src/assets/svg/info.svg";
// import { IconWithTooltip } from "./IconWithTooltip";
import React from "react";
import clsx from "clsx";

export interface ConsentField {
  id: string;
  content: React.ReactNode;
  required?: boolean;
}

export interface ConditionsProps {
  title: string;
  subtitle?: string;
  fields: ConsentField[];
  selected?: string[];
  onChange?: (values: string[]) => void;
  setErrors: React.Dispatch<React.SetStateAction<string[]>>;
  errors?: string[];
  inputRefs: React.MutableRefObject<Record<string, HTMLElement | null>>;
  theme?: string;
}

export function Conditions({
  title,
  subtitle,
  fields,
  selected = [],
  onChange,
  setErrors,
  errors,
  inputRefs,
  theme = "white",
}: ConditionsProps) {
  const handleSelect = (value: string, required?: boolean) => {
    let updatedSelection = [...selected];

    const isSelected = updatedSelection.includes(value);

    if (isSelected) {
      updatedSelection = updatedSelection.filter((item) => item !== value);

      if (required) {
        setErrors((prevErrors) => [...prevErrors, value]);
      }
    } else {
      updatedSelection.push(value);

      if (required) {
        setErrors((prevErrors) => prevErrors.filter((e) => e !== value));
      }
    }

    onChange?.(updatedSelection);
  };

  return (
    <div className="flex flex-col gap-4">
      <h3
        className={clsx(
          "flex justify-between text-[17px] font-bold  tracking-tightest uppercase",
          theme === "black" && "text-white",
        )}
      >
        {title}

        {/* <IconWithTooltip
          content={"Aaaaa"}
          icon={<img src={Info} alt="Info" className="cursor-pointer" />}
        /> */}
      </h3>
      {/* {subtitle && (
        <h4 className="text-sm text-opacity-90">
          {subtitle}
        </h4>
      )} */}
      {fields.map(({ id, content, required }) => {
        const isError = required && errors?.includes(id);

        return (
          <div key={id} className="flex gap-4">
            <label
              className={clsx(
                "flex items-start gap-3 cursor-pointer ",
                theme === "black" ? "hover:bg-gray-900" : "hover:bg-gray-100",
              )}
            >
              <input
                ref={(el) => (inputRefs.current[id] = el)}
                id={id}
                type="checkbox"
                checked={selected.includes(id)}
                onChange={() => handleSelect(id, required)}
                className="mt-1 form-checkbox text-primary-blue"
                required={required}
              />
              <span
                className={clsx(
                  "text-[13px]  opacity-90",
                  theme === "black" && "text-white",
                )}
              >
                {required && (
                  <span className="pr-1 text-xs text-warning-red">*</span>
                )}
                {content}
                {isError && (
                  <div className="flex items-center gap-1 mt-1 text-xs text-warning-red">
                    <img src={Warning} alt="Warning" />
                    Ovo polje je obavezno.
                  </div>
                )}
              </span>
            </label>
          </div>
        );
      })}
    </div>
  );
}

export default Conditions;
